import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import ApplyWithMobile from './components/ApplyWithMobile';
import ApplicationForm from './components/ApplicationForm';
import SubmissionSuccess from './components/SubmissionSuccess';
import CheckStatus from './components/CheckStatus';
import StatusResult from './components/StatusResult';
import './index.css';

function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <Navbar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<ApplyWithMobile />} />
            <Route path="/application-form" element={<ApplicationForm />} />
            <Route path="/success/:applicationId" element={<SubmissionSuccess />} />
            <Route path="/check-status" element={<CheckStatus />} />
            <Route path="/status-result" element={<StatusResult />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;